<template>
	<div v-if="visible">
		<el-dialog class="close-private"
							 :visible.sync="visible"
							 :title="$t('listPage.text.reInstallSystem')"
							 :close-on-click-modal="false"
							 :before-close="handleClose">
			<div class="i-text">
				<div v-if = "retailTipChange==='retail'" class="tip-warning mb20" style="line-height: 19px"
						 v-html="$t('privateNetInstance.reInstallTip1')">
				</div>
				<div v-else class="tip-warning mb20" style="line-height: 19px"
						 v-html="$t('privateNetInstance.reInstallTip1')+$t('privateNetInstance.reInstallTip2')">
				</div>
			</div>
			<div class="reinstall-tip">
				{{$t('listPage.speechCraft.ReSureInstall', [rowInfo.name])}}
			</div>
			<el-checkbox v-model="reinstallConfirmChecked" class="reinstall-confirm-checkbox"
									 v-if="formInfo.checked">
				{{$t('listPage.speechCraft.reinstallConfirmCheckWarning',
				[getDataDiskCardTitle(formInfo.dataRaidType, rowInfo.deviceType)])}}
			</el-checkbox>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelSys">{{ $t('privateNetInstance.cancel') }}</el-button>
				<el-button @click="openOperationProtect(OperationConstant.REINSTALL)" type="primary"
									 :disabled="secondReinstallConfirmDisabled">
					{{$t('privateNetInstance.sure')}}
				</el-button>
			</div>
		</el-dialog>
		<jcb-opt-protect :visible.sync="operationProtectVisible" :action-type="actionType"
										 @success="onSuccess" @error="onError">
		</jcb-opt-protect>
	</div>
</template>

<script>
	import operationProtect from '@/mixins/operationProject';
	import { OperationConstant } from '@/common/Constants';

	export default {
		name: 'ReSysConfirm',
		mixins:[operationProtect],
		props: {
		visible: {
			type: Boolean,
			default: false
		},
		formInfo: {
			type: Object,
			default: () => {}
		},
		rowInfo: {
			type: Object,
			default: () => {}
		},
		retailTipChange:{
			type:String,
			default:''
		}
	},
	data() {
		return {
			// 是否勾选了二次确认的checkbox
			reinstallConfirmChecked: false,
			// 操作保护弹框是否显示
			operationProtectVisible: false,
			// 操作保护用到：区分当前物理机是什么类型：vpc/basic
			instanceType: 'vpc'
		};
	},
	computed: {
		OperationConstant: () => OperationConstant,
		// 重装系统二次弹框确认键是否置灰
		secondReinstallConfirmDisabled: function() {
			// 第一次勾选格式化数据，第二次没有同意
			return this.formInfo.checked && !this.reinstallConfirmChecked
		}
	},
	methods: {
		handleClose() {
			this.$emit('update:visible', false);
		},
		cancelSys() {
			this.handleClose();
		},
		sureSys() {
			this.systemReinstallTwiceConfirm();
		},
		systemReinstallTwiceConfirm(headers) {
			const params = {
				instanceId: this.rowInfo.instanceId,
				region: this.rowInfo.region,
				az: this.rowInfo.az,
				imageType: 'standard',
				keepData: this.formInfo.checked ? 'no' : 'yes',
				//password: this.formInfo.password,
				clientToken: Normal.getClientToken(),
				osTypeId: this.formInfo.osTypeId,
				sysRaidTypeId: this.rowInfo.sysRaidTypeId,
				dataRaidTypeId: this.formInfo.checked
					? this.formInfo.dataRaidTypeId
					: this.rowInfo.dataRaidTypeId,
				userData: this.formInfo.advancedSetting
					? this.formInfo.userData
					: undefined,
				loginType: this.formInfo.loginType, // 登录方式
				systemDiskPartitions: this.formInfo.systemDiskPartitions, //系统盘分区
				dataDiskPartitions: this.formInfo.dataDiskPartitions //数据盘分区
			};
			if (this.formInfo.hostname !== '') {
				params.hostname = this.formInfo.hostname;
			}
			if (this.formInfo.loginType === 'keyPair') {
					params.keyPairId = this.formInfo.password; 
				if (this.formInfo.password === '') {
					params.keyPairId = this.formInfo.selectKey;
                	params.keypairIdSos = this.formInfo.sosKey;
				}
			} else if (this.formInfo.loginType === 'pwd') {
				params.password = this.formInfo.password;
				if(this.formInfo.selectKey !== '') {
					params.keypairIdSos = this.formInfo.selectKey;
				}
			}
			let dealHeaders = Object.assign({},headers,{'Content-Type': 'application/json'});
			Ajax.post('/api/cps/reinstallInstance', params, {
				headers: dealHeaders
			}).then((res) => {
				if (res.data) {}
			}).catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
			}).finally(() => {
				this.$emit('refresh');
				this.handleClose();
			});
		},
		/**
		 * 根据raid类型和机型返回展示名称
		 * @param raidType
		 * @param deviceType
		 * @return {*}
		 */
		getDataDiskCardTitle(raidType, deviceType) {
			if (raidType === 'RAID51H') {
				if (deviceType === 'cps.c.perf3') {
					return 'RAID 5+1 hotspare';
				} if (deviceType === 'cps.s.perf1') {
					return 'RAID 5+1 hotspare+NO RAID';
				}
			} else {
				return raidType;
			}
		}
	}
};
</script>

<style lang="scss">
	.close-private {
		.reinstall-tip {
			width:100%;
			font-size:15px;
			color:#797979;
			text-align:center;
			word-break: break-word;
		}

		.reinstall-confirm-checkbox{
			margin-top: 30px;
			margin-bottom: -20px;
			.el-checkbox__label{
				color:rgb(121, 121, 121)
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/privateNetInstance/operates/ReSysConfirm.vue